// test1608
(1608 && 0);
